import { render, staticRenderFns } from "./RecordsDetail.vue?vue&type=template&id=f2e95daa&scoped=true&"
import script from "./RecordsDetail.vue?vue&type=script&lang=js&"
export * from "./RecordsDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecordsDetail.vue?vue&type=style&index=0&id=f2e95daa&prod&lang=less&scoped=true&"
import style1 from "./RecordsDetail.vue?vue&type=style&index=1&id=f2e95daa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e95daa",
  null
  
)

export default component.exports